export interface Testimonial {
  id: string;
  attribution: string;
  quote: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 'testimonial-simons-mom',
    attribution: "Simon's Mom",
    quote:
      "My eldest son loves this writing program! He used to struggle with putting his thoughts on paper, but now he's excited to write stories and essays. The teachers are patient, encouraging, and really know how to bring out the best in kids.",
    rating: 5,
  },
  {
    id: 'testimonial-emilys-mom',
    attribution: "Emily's Mom",
    quote:
      "Before EiFO, she didn't know how or what to write. Now she writes confidently and even enjoys it! The structured curriculum and supportive teachers made all the difference. I'm so grateful we found this program.",
    rating: 5,
  },
  {
    id: 'testimonial-lucas-mom',
    attribution: "Lucas' Mom",
    quote:
      "My son's writing and reading both have improved rapidly! The live classes keep him engaged and the teachers provide personalized feedback. We've seen a real difference in his schoolwork.",
    rating: 5,
  },
  {
    id: 'testimonial-chloe-sophies-parents',
    attribution: "Chloe & Sophie's Parents",
    quote:
      "Our oldest daughter enrolled in the writing program last year and loved it so much that we signed up our younger daughter too. Both girls have grown tremendously in their writing skills and confidence.",
    rating: 5,
  },
  {
    id: 'testimonial-yuris-mom',
    attribution: "Yuri's Mom",
    quote:
      "My daughter Yuri loves this program! She's become a much stronger writer and reader. The teachers are wonderful — they make learning fun while maintaining high standards. Highly recommend!",
    rating: 5,
  },
  {
    id: 'testimonial-seans-mom',
    attribution: "Sean's Mom",
    quote:
      "It's a great school! My son has taken writing, vocabulary and reading classes. Each class has helped him improve. The teachers are professional and caring, and the class sizes are perfect for individual attention.",
    rating: 5,
  },
  {
    id: 'testimonial-nick-leos-mom',
    attribution: "Nick & Leo's Mom",
    quote:
      "I've signed up for my eldest son Nick last year and he improved so much that I enrolled my younger son Leo too. The curriculum is well-structured and the teachers truly care about each student's progress.",
    rating: 5,
  },
  {
    id: 'testimonial-angelina-lucas-mom',
    attribution: "Angelina and Lucas' Mom",
    quote:
      "My Angelina was struggling at ELA and we decided to try EiFO. What a difference! Her grades improved and she actually enjoys writing now. We enrolled Lucas too and he's thriving in the reading program.",
    rating: 5,
  },
];
